import { render, staticRenderFns } from "./settleDetails.vue?vue&type=template&id=64d3ab8e&scoped=true"
import script from "./settleDetails.vue?vue&type=script&lang=ts"
export * from "./settleDetails.vue?vue&type=script&lang=ts"
import style0 from "./settleDetails.vue?vue&type=style&index=0&id=64d3ab8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d3ab8e",
  null
  
)

export default component.exports